import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { BrandLogo } from "@/components/BrandLogo";
import { CheckCircle2, Loader2 } from "lucide-react";

export default function Unsubscribe() {
  const { token } = useParams();
  const [info, setInfo] = useState(null);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api.get(`/listings/unsubscribe/${token}`).then((r) => setInfo(r.data)).catch((e) => setError(formatApiErrorDetail(e.response?.data?.detail)));
  }, [token]);
  const go = async () => {
    setBusy(true);
    try { await api.post(`/listings/unsubscribe/${token}`); setInfo({ ...info, unsubscribed: true }); } catch (e) { setError(formatApiErrorDetail(e.response?.data?.detail)); } finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen bg-background flex flex-col items-center px-4 pt-10">
      <BrandLogo size="md" />
      <Card className="p-6 sm:p-8 mt-8 max-w-md w-full text-center space-y-4" data-testid="unsubscribe-card">
        {error && <p data-testid="unsubscribe-error">{error}</p>}
        {!error && !info && <Loader2 className="h-6 w-6 animate-spin text-kinetic mx-auto" />}
        {info && info.unsubscribed && (
          <div data-testid="unsubscribe-done" className="space-y-2">
            <CheckCircle2 className="h-10 w-10 text-emerald-600 mx-auto" />
            <p className="font-bold">{info.business_name} is unsubscribed</p>
            <p className="text-sm text-muted-foreground">You won't receive any more lead emails from MoveTender.</p>
          </div>
        )}
        {info && !info.unsubscribed && (
          <>
            <p className="font-bold">Stop lead emails for {info.business_name}?</p>
            <p className="text-sm text-muted-foreground">You'll no longer be told about moves posted in your area.</p>
            <Button onClick={go} disabled={busy} variant="destructive" data-testid="unsubscribe-confirm-btn">Unsubscribe</Button>
          </>
        )}
      </Card>
    </div>
  );
}
